import React, {useEffect, useState} from "react";
import {DropdownItem} from "utils/general-models";
import {Dropdown, DropdownChangeEvent} from "primereact/dropdown";
import {useGetProductTemplateInfos} from "api/api-hooks/product-templates-hooks";
import {T} from "services/lang/LanguageService";

export interface IProductTemplateDropdownChangeEvent {
  value: number;
  refName: string;
}

interface IProductTemplateDropdownProps {
  value?: number | null;
  onChange?: (e: IProductTemplateDropdownChangeEvent) => void;
}

interface ProdTemplateDropdownItem extends DropdownItem<number> {
  refName: string;
}

export function ProductTemplateDropdown(props: IProductTemplateDropdownProps) {
  const [allSelections, setAllSelections] = useState<ProdTemplateDropdownItem[]>([]);

  const query = useGetProductTemplateInfos();
  useEffect(() => {
    if (query.data) {
      const selections = query.data.map(it => ({
        value: it.id,
        label: it.displayName,
        refName: it.refName,
      }));
      setAllSelections(selections);
    }
  }, [query.data]);

  const onChange = (e: DropdownChangeEvent) => {
    const refName = allSelections.find(it => it.value === e.value)?.refName;
    props.onChange?.({ value: e.value, refName: refName!! });
  };

  let placeholderText;
  if (query.error) {
    placeholderText = T("error.product-template-selection-error");
  } else if (query.isLoading && !query.error) {
    placeholderText = T("message.product-templates-loading");
  } else {
    placeholderText = T("message.select-product-template");
  }

  return (
    <>
      {query.error && <span>{T("error.product-template-selection-error")}</span>}

      {query.isLoading && !query.error && <span>{T("message.product-templates-loading")}</span>}

      {query.isSuccess && (
        <Dropdown
          placeholder={placeholderText}
          value={props.value || null}
          options={allSelections}
          className="h-max"
          filter
          filterMatchMode="contains"
          onChange={onChange}
        />
      )}
    </>
  );
}
